module.exports = __webpack_public_path__ + "img/6.7776267b.png";